const STORAGE_KEY = 'crmClientDrawerRestore';

export type CrmClientDrawerRestorePayload = {
  clientId: number;
  mode: 'view';
};

export function saveCrmClientDrawerRestore(clientId: number): void {
  const payload: CrmClientDrawerRestorePayload = { clientId, mode: 'view' };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function readCrmClientDrawerRestore(): CrmClientDrawerRestorePayload | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (raw == null || raw === '') return null;
  try {
    const parsed = JSON.parse(raw) as CrmClientDrawerRestorePayload;
    if (
      typeof parsed?.clientId === 'number' &&
      Number.isFinite(parsed.clientId) &&
      parsed.mode === 'view'
    ) {
      return parsed;
    }
  } catch {
    // ignore malformed payload
  }
  return null;
}

export function clearCrmClientDrawerRestore(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
